import React, { useEffect } from "react"

declare global {
  interface Window {
    DG_CHAT_WIDGET_CONFIG: {
      flowUrl: string
      widgetId: string
    }
    dgchat: any
  }
}

export const GeniusChat: React.FC = () => {
  useEffect(() => {
    window.DG_CHAT_WIDGET_CONFIG = {
      flowUrl: "https://flow-server.eu.dgdeepai.com",
      widgetId: "092fd66d-3d65-4572-aba8-d735ff098b05",
    }

    const geniusChatScript = document.createElement("script")
    geniusChatScript.defer = true
    geniusChatScript.src =
      "https://chat-assets.digitalgenius.com/dgchatinit.widget.v1.1.0.min.js"
    geniusChatScript.integrity =
      "sha384-YkjwDuty32A4tGb7KQ12oI2fGs7H8ZYWqexJXRl+AGJA997fMJV32cVof8u4XLYz"
    geniusChatScript.crossOrigin = "anonymous"

    geniusChatScript.onload = () => {
      if (window.dgchat && typeof window.dgchat.init === "function") {
        window.dgchat.init()
      } else {
        console.error("Error: DG Chat initialization failed.")
      }
    }
    document.head.appendChild(geniusChatScript)
  }, [])

  return <div id="dg-chat-container" />
}
